import { render, staticRenderFns } from "./VeiculosOrdensServico.vue?vue&type=template&id=5f256bd0&scoped=true&"
import script from "./VeiculosOrdensServico.vue?vue&type=script&lang=js&"
export * from "./VeiculosOrdensServico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f256bd0",
  null
  
)

export default component.exports